<template>
  <svg :viewBox="viewBox" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path :d="points" :stroke-width="strokeWidth"></path>
  </svg>
</template>

<script>
  export default {
    name: 'circle-progress',
    props: {
      progress: {
        type: Number,
        required: true
      },
      radius: {
        type: Number,
        required: true
      },
      strokeWidth: {
        type: Number,
        required: true
      },
      strokeColor: {
        type: String,
        default: '#FFFFFF'
      }
    },
    computed: {
      cx () {
        const { progress, radius } = this.$props
        const degrees = progress * 360
        const rad = degrees * (Math.PI / 180)
        return ((Math.sin(rad) + 1) * radius).toFixed(2)
      },
      cy () {
        const { progress, radius } = this.$props
        const degrees = progress * 360
        const rad = degrees * (Math.PI / 180)
        return ((1 - Math.cos(rad)) * radius).toFixed(2)
      },
      viewBox () {
        const { radius, strokeWidth } = this.$props
        return `-${strokeWidth / 2} -${strokeWidth / 2} ${radius * 2 + strokeWidth} ${radius * 2 + strokeWidth}`
      },
      points () {
        const { progress, radius } = this.$props
        return this.draw(progress, radius)
      }
    },
    methods: {
      draw (progress, radius) {
        const degrees = progress * 360
        const rad = degrees * (Math.PI / 180)
        const x = ((Math.sin(rad) + 1) * radius).toFixed(2)
        const y = ((1 - Math.cos(rad)) * radius).toFixed(2)
        const lenghty = degrees > 180 ? 1 : 0
        return `M ${radius} 0 A ${radius} ${radius} 0 ${lenghty} 1 ${x} ${y}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CircleProgress.vue?33d5acf6